module.exports = __webpack_public_path__ + "img/logo-type2-v2.0.8cec47b7.png";